import { BUCKET_END_WARNING_TEXT } from "@/lib/buckets/bucketEndWarning";
import { Clock } from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@workspace/ui/components/alert-dialog";

interface BucketEndWarningDialogProps {
  open: boolean;
  dismiss: () => void;
}

export function BucketEndWarningDialog({ open, dismiss }: BucketEndWarningDialogProps) {
  return (
    // Escape closes through onOpenChange as well, so it counts as Okay.
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) dismiss();
      }}
    >
      <AlertDialogContent data-testid="bucket-end-warning" className="data-[size=default]:sm:max-w-md">
        <AlertDialogHeader className="gap-2">
          <AlertDialogTitle className="flex items-center gap-2 text-lg">
            <Clock className="size-5 shrink-0 text-primary" aria-hidden="true" />
            {BUCKET_END_WARNING_TEXT.TITLE}
          </AlertDialogTitle>
          <AlertDialogDescription>{BUCKET_END_WARNING_TEXT.BODY}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {/* No Cancel button, so Radix focuses nothing on open; focus Okay ourselves so the dialog is reachable and announced. */}
          <AlertDialogAction autoFocus data-testid="bucket-end-warning-okay">
            {BUCKET_END_WARNING_TEXT.OKAY}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
